<style scoped>
  .expand-row{
    margin-bottom: 16px;
  }
</style>
<template>
  <div>
    <div>
    <Row class="expand-row">
      <Col span="2" v-for="item in itemList">
      <Tooltip :content="item.descr">
      <a class="expand-value" @click="editItem(item.id)">{{ item.title }}</a>
      </Tooltip>
      </Col>
    </Row>
    </div>
  <EditItemModal :itemId="itemId" :value="editModal"></EditItemModal>
  </div>
</template>
<script>
  import EditItemModal from './modal/EditItemModal.vue'
  export default {
    components: {
      EditItemModal },
    props: {
      row: Object
    },
    data () {
      return {
        itemId: null,
        itemList: [],
        editModal: false,
      }
    },
    mounted: function () {

    },
    created: function () {
      let self = this
      let parent = localStorage.getItem('parentRow')
      self.$http.get('/adminConfig/getItemByParentId?parentId=' + parent).then(function (res) {
        if (res.data) {
          self.itemList = res.data
        }
      })
    },
    methods: {
      editItem (id) {
        let self = this
        self.itemId = id
        self.editModal = true
      },
    },
    watch: {
    }
  }
</script>



// WEBPACK FOOTER //
// AdminConfigExpand.vue?a22066fe